import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'
import { CardsResponseData } from 'src/api/common/lists/lists-api'

let lastInitTimestamp: number | null

export const cardsAtom = createPrimitiveAtom<Record<string, CardsResponseData>>({})

export async function updateCardsAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getCards()
  const record = indexBy(x => x.name, data)
  dispatch(cardsAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}
